import avaxImg from '../assets/images/marketplace/Vector.svg'

export const COLLECTION_STATISTICS = [
    {number: 369, currency: false, title: 'Items'},
    {number: 154, currency: false, title: 'owners'},
    {number: '6,7k', currency: avaxImg, title: 'floor price'},
    {number: '6,7k', currency: avaxImg, title: 'total volume'},
]

export const CHIKN_SOCIALS = [
    {link: 'https://discord.com/invite/9znHkBYjra'},
    {link: 'https://twitter.com/chikn_nft'},
    {link: 'https://medium.com/@chikn_farm'},
]

export const NFKEY_SOCIALS = [
    {link: 'https://twitter.com/0xNFTreasure'},
    {link: 'https://discord.gg/5VYy94gP5J'},
]
